import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { Authentication } from '@leedpulse-monorepo/classes';
import Subscription from '../../models/Subscription';

async function removeUserFromSubscription(
  subscription: Subscription,
  auth: Authentication,
  email: string
): Promise<Subscription> {
  try {
    return await HttpClient.put('/subscription/user/remove', {}, auth.token, {
      'x-api-key': subscription.apiKey,
      'x-user-uid': auth.id,
      'x-user-email': email,
    });
  } catch (e) {
    throw new RemoveUserFromSubscriptionStatusFailure();
  }
}

export class RemoveUserFromSubscriptionStatusFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default removeUserFromSubscription;
